import styled, { css } from "styled-components/macro";

const textareaBaseStyles = css`
  margin: 0 !important;
  overflow: hidden;
  width: 100%;
  resize: none;
  min-height: 120px;
  ::placeholder {
    color: var(--grey-1);
  }

  &.short {
    min-height: 120px;
  }
`;

export const TextareaContainer = styled.div`
  position: relative;
  border: 1px solid var(--grey-3);
  box-shadow: var(--tiny-drop-shadow);
  border-radius: 5px;
  margin: 0 !important;
  overflow: hidden;
  width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: var(--primary-cta);
    box-shadow: var(--tiny-drop-shadow), 0 0 0 1px var(--primary-cta-transparent-30);
  }

  textarea {
    border: unset !important;
    box-shadow: none;
    border-radius: 0;
    ${textareaBaseStyles}

    &::selection {
      background: var(--text-highlight);
    }
    &::-moz-selection {
      background: var(--text-highlight);
    }
  }

  /* Make textarea background transparent when highlights are active - applied at top level for reliability */
  ${(props) => props.$hasHighlights && css`
    textarea {
      background-color: transparent !important;
      position: relative;
      z-index: 2;
    }
  `}
  .textarea-info {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 14px;
    left: 18px;
    right: 18px;
    font-size: 12px;
    font-weight: 500;
    color: var(--grey-1);
  }

  .help-text {
    text-align: left;
  }
`;

/* Highlight backdrop - sits behind the textarea with matching styles */
export const HighlightBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: hidden;
  pointer-events: none;
  margin: 0;

  /* Text rendering - must match textarea exactly */
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;

  /* Border is transparent but takes up same space as textarea border */
  border-style: solid;
  border-color: transparent;

  /* Text should be invisible - only highlights show */
  color: transparent;
  background-color: var(--document-background, #fff);
  border-radius: 5px;

  /* Search highlight styles - use mark element - match editor theme */
  mark {
    color: transparent;
    background-color: var(--text-highlight);
    border-radius: 2px;
  }

  mark.search-highlight-selected {
    background-color: var(--primary-cta-transparent-30);
    outline: 1px solid var(--primary-cta-high-contrast);
  }
`;

export const WordCountContainer = styled.div`
  padding-right: ${(props) => props.offsetWordCount ?? 0}px;
  text-align: right;
`;
